import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const SpinMeta: ComponentMeta = {
  componentName: "Spin",
  package: "@mijadesign/web",
  title: "加载中",
  description: "表示加载中的状态",
  category: ComponentCategory.FEEDBACK,
  icon: "LoadingOutlined",
  canHaveChildren: true,
  visibleInComponentPanel: true,
  props: [
    {
      name: "spinning",
      label: "是否加载中",
      type: PropType.BOOLEAN,
      bindable: true,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "default",
      options: [
        { label: "小", value: "small" },
        { label: "默认", value: "default" },
        { label: "大", value: "large" },
      ],
      group: "样式",
    },
    {
      name: "tip",
      label: "提示文字",
      type: PropType.STRING,
      group: "基础",
    },
  ],
  defaultProps: {
    spinning: false,
    size: "default",
  },
  preview: [
    {
      title: "加载中",
      props: {
        spinning: true,
        tip: "加载中",
      },
    },
    {
      title: "大尺寸",
      props: {
        spinning: true,
        size: "large",
        tip: "处理中",
      },
    },
  ],
  docLinks: [
    {
      title: "Spin 文档",
      url: "https://https://5x-ant-design.antgroup.com//components/spin-cn",
      source: "antd",
    },
  ],
  npm: {
    package: "@mijadesign/web",
    exportName: "Spin",
  },
  snippet: {
    componentName: "Spin",
    package: "@mijadesign/web",
    props: {
      spinning: false,
    },
  },
};
